import React, { Component } from "react"
import theme                from "../../../utils/theme"
import Slice                from "./slice"

const getStatusColor = (type) => {
    switch (type) {
        case "implementation":
            return theme.sec.blue

        case "not_started":
            return theme.dark.charcoalGrey

        case "cancelled":
            return theme.sec.red

        case "pipeline":
            return theme.sec.gray

        case "completion":
            return theme.sec.green
      
        case "Submitted":
            return theme.sec.blue
      
        case "Evaluated":
            return theme.sec.green

        default:
            return theme.dark.charcoalGrey
    }
}

export default class PieChart extends Component {
    render() {
        let {
            labels,
            hole,
            radius,
            data,
            stroke,
            strokeWidth,
        } = this.props

        const pieData = Object.values(data)
        let diameter = radius * 2
        let startAngle
        let sum = pieData && pieData.reduce((carry, current) => carry + current, 0)
        startAngle = 0

        return (
            <svg
                width={diameter}
                height={diameter}
                viewBox={"0 0 " + diameter + " " + diameter}
            >
                {Object.keys(data)
                       .map(function(status, sliceIndex) {
                           let slice = data[status]
                           if (slice !== 0) {
                               let angle, nextAngle, percent
                               nextAngle = startAngle
                               /**
                                * slice component path not closed
                                * -0.0001 to fix the wired circle disappearing problem when circle is 360
                                */
                               angle = (slice / sum) * 360 - 0.0001 || 0
                               percent = (slice / sum) * 100 || 0
                               startAngle += angle

                               return (
                                   <Slice
                                       key={sliceIndex}
                                       value={slice}
                                       percent={percent}
                                       percentValue={percent.toFixed(1)}
                                       startAngle={nextAngle}
                                       angle={angle}
                                       radius={radius}
                                       hole={radius - hole}
                                       trueHole={hole}
                                       showLabel={labels}
                                       fill={getStatusColor(status)}
                                       stroke={stroke}
                                       strokeWidth={strokeWidth}
                                   />
                               )
                           }

                           return ""
                       })}
            </svg>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/visualization/pieChart/pieChart.js